import Navbar from "../navbar/Navbar";
import SubscriptionsSidebar from "../sidebar/SubscriptionsSidebar";

function SubscriptionsWrapper({ children, sidebarOpen, toggleSidebar }) {
  return (
    <>
      <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      {children}
      <SubscriptionsSidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
    </>
  );
}

export default SubscriptionsWrapper;
